module.exports = __webpack_public_path__ + "img/yjfx-img1.acc97367.png";